import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicledata/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicledata/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicledata/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicledata/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicledata/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const querySingleVehicleInfo = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicledata/querysinglevehicleinfo/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const sendSingleDlysjgParamCmd = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicledata/sendsingledlysjgparamcmd/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const sendSingleGdDlysjgOffline = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicledata/sendsinglegddlysjgoffline/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const syncJt808TerminalNum = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicledata/syncjt808terminalnum' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const sendToGdDlysjgOffline = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicledata/sendtogddlysjgoffline' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const queryVehicleInfos = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicledata/queryvehicleinfos' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

